import { Enumeration } from './Enumeration';

class SplitSalesShareEnum extends Enumeration {
  FiftyFifty = 50;
  EightyTwenty = 80;

  constructor() {
    super();
    return Object.freeze(this);
  }
}

export const SplitSalesShare = new SplitSalesShareEnum();

export const getLabelForSplitShare = share => {
  if (share === SplitSalesShare.FiftyFifty) return '50/50 %';
  if (share === SplitSalesShare.EightyTwenty) return '80/20 %';
};
